/**
 * Created on 25/8/19.
 */
export default {
    headerRow: ['Prorata Share', 'Lease Type', 'Annual Taxes', 'PSF', 'Annual Insurance', 'PSF', 'Annual CAM', 'PSF', 'Annual Mgmt. Fee', 'PSF', 'Annual Total', 'PSF'],
    rows: {'no-row': {valueCells: []}}
}